import { format } from "date-fns";

import type { LineageNode } from "src/graphql";

export type LineageExportNode = Pick<
  LineageNode,
  | "id"
  | "resourceType"
  | "resourceId"
  | "kind"
  | "exists"
  | "name"
  | "locationData"
>;

/**
 * Names an export after what it was taken from and when, so exports of
 * different resources or rebuilds do not overwrite each other in the downloads
 * folder.
 */
export function buildLineageExportFilename({
  subject,
  kind,
  extension,
  exportedAt,
}: {
  subject: string;
  kind: string;
  extension: "csv" | "xlsx";
  exportedAt: Date;
}): string {
  const slug = subject.toLowerCase().replace(/[^a-z0-9]/g, "_");
  return `${slug}-${kind}-${format(exportedAt, "yyyyMMddHHmmss")}.${extension}`;
}
